<div>
  <mat-label>{{title}}</mat-label>
</div><br>
<form #form="ngForm">
  <mat-form-field class="input-margin">
    <mat-label>
      予定日齢
    </mat-label>
    <input matInput required placeholder="予定日齢" type="number" min="0"
           name="yoteiNichirei" [(ngModel)]="meisai.yoteiNichirei">
  </mat-form-field>
  <mat-form-field class="input-margin" *ngIf="shubetsu === 'saizaiNittei' || shubetsu === eventShubetsuExceptOtherObj.saizai.eventShubetsu">
    <mat-label>
      種類
    </mat-label>
    <input matInput required placeholder="種類"
           name="shubetsu" [(ngModel)]="meisai.shubetsu">
  </mat-form-field>
  <div *ngIf="shubetsu === 'vaccineProgram'|| shubetsu === eventShubetsuExceptOtherObj.vaccine.eventShubetsu">
    <ng-select style="width: 180px"
               required
               class="custom"
               [items]="masterService.vaccineMaster[0].vaccines"
               bindLabel="vaccineName"
               bindValue="id"
               placeholder="ワクチン*"
               notFoundText="一致するワクチンがありません"
               appendTo="body"
               [closeOnSelect]="true"
               [multiple]="false"
               [searchFn]="commonService.vaccineSearchFn"
               [(ngModel)]="meisai.vaccineId"
               name="vaccineName">
      <ng-template ng-option-tmp let-item="item">
        <div class="ng-select-option-inner-div">
          <span class="ng-select-option-main-row">{{item.vaccineName}}</span>
          <br>
          <span class="ng-select-option-sub-row">{{commonService.vaccineDetailText(item)}}</span>
        </div>
      </ng-template>
    </ng-select>
    <mat-form-field class="input-margin">
      <mat-label>
        株
      </mat-label>
      <input matInput placeholder="株" disabled
             name="vaccineKabu" [ngModel]="commonService.getName(masterService.vaccineMaster[0].vaccines, meisai.vaccineId, 'vaccineKabu')">
    </mat-form-field>
    <mat-form-field class="input-margin">
      <mat-label>
        メーカー
      </mat-label>
      <input matInput placeholder="メーカー" disabled
             name="maker" [ngModel]="commonService.getName(masterService.vaccineMaster[0].vaccines, meisai.vaccineId, 'maker')">
    </mat-form-field>
    <mat-form-field class="input-margin">
      <mat-label>
        投与方法
      </mat-label>
      <input matInput placeholder="投与方法" disabled
             name="touyoHouhou" [ngModel]="commonService.getName(masterService.vaccineMaster[0].vaccines, meisai.vaccineId, 'touyoHouhou')">
    </mat-form-field>
    <mat-form-field class="input-margin">
      <mat-label>
        ドース
      </mat-label>
      <input matInput placeholder="ドース" disabled
             name="dose" [ngModel]="commonService.getName(masterService.vaccineMaster[0].vaccines, meisai.vaccineId, 'dose')">
    </mat-form-field>
  </div>
</form>
<div mat-dialog-actions align="end"
     [matTooltip]="commonService.getAlertTooltipMessage(form)"
     matTooltipPosition="right"
     style="width: fit-content">
  <button mat-button mat-flat-button color="primary" (click)="commonService.onClick(this.matDialogRef, meisai)" [disabled]="form.invalid || !form.dirty">
    <span>Enter</span>
  </button>
</div>

